import React, { useState } from "react";
import { Input, Button } from "antd";
import { ScanOutlined } from "@ant-design/icons";
import Code128ScannerModal from "./Code128ScannerModal/Code128ScannerModal";

const BatchNumberInput: React.FC<{
  value?: number | undefined;
  onChange?: (value: string | undefined) => void;
  setCode2?: (value: string | undefined) => void; // the pallet id part of the barcode
  disabled?: boolean;
}> = ({ value, onChange, setCode2, disabled = false }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleScan = (code) => {
    console.log("Handling scan: ", code);
    if (onChange) {
      onChange(code.split("-")[0]);
      if (setCode2 && code.split("-").length > 1) {
        setCode2(code.split("-")[1]);
      }
    }
    setIsModalOpen(false);
  };

  const handleInputChange = (e) => {
    if (onChange) {
      onChange(e.target.value.toUpperCase());
    }
  };

  return (
    <div style={{ display: "flex", gap: 8, justifyContent: "space-between", alignItems: "stretch", position: "relative" }}>
      <Input value={value} onChange={handleInputChange} disabled={disabled} />
      {/*Not sure why, but stretch will not work directy on the Button component so wrapping it in a div*/}
      <div>
        <Button icon={<ScanOutlined />} onClick={() => setIsModalOpen(true)} style={{ minWidth: 35, height: "100%" }} />
      </div>
      <Code128ScannerModal open={isModalOpen} setOpen={setIsModalOpen} setCode={handleScan} />
    </div>
  );
};

export default BatchNumberInput;
